import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone } from 'lucide-react';
import { companyInfo, footerLinks } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="/assets/img/brand/logo-light.png" 
              alt="IP Partners Inc" 
              className="h-8 w-auto mb-4"
            />
            <p className="text-gray-400 mb-4">
              Professional legal services you can trust for business, personal, and intellectual property matters.
            </p>
          </div>

          {/* Legal Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">{footerLinks.services.title}</h4>
            <ul className="space-y-2">
              {footerLinks.services.links.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-sm hover:text-brown-500 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">{footerLinks.quickLinks.title}</h4>
            <ul className="space-y-2">
              {footerLinks.quickLinks.links.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-sm hover:text-brown-500 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Information */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact Information</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-brown-600 flex-shrink-0 mt-1" />
                <span className="text-sm">{companyInfo.address}</span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-brown-600 flex-shrink-0" />
                <a href={`tel:${companyInfo.phone}`} className="text-sm hover:text-brown-500 transition-colors">
                  {companyInfo.phone}
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-brown-600 flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="text-sm hover:text-brown-500 transition-colors">
                  {companyInfo.email}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © 2026 IP Partners Inc. All rights reserved.
            </p>
            <div className="flex items-center space-x-4 text-sm text-gray-400">
              <Link to="/disclaimer" className="hover:text-brown-500 transition-colors">
                Disclaimer
              </Link>
              <span>|</span>
              <Link to="/privacy" className="hover:text-brown-500 transition-colors">
                Privacy Policy
              </Link>
              <span>|</span>
              <Link to="/terms" className="hover:text-brown-500 transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
